import BANKING_ADMIN from './bankingAdmin'

export default { ...BANKING_ADMIN }
